import { Outlet } from 'react-router-dom'

export default function ProfileHome() {
  return (
    <Outlet/>
  )
}